// src/components/Admin/CategoryList.js

import React, { useEffect, useState } from 'react';
import { getPlantCategories } from '../../services/plantService';
import AddEditPlantCategoryForm from './AddEditPlantCategoryForm';

function PlantCategoryList() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = () => {
        setLoading(true);
        getPlantCategories()
            .then((response) => {
                setCategories(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    const handleAddCategory = () => {
        setSelectedCategory(null);
        setShowModal(true);
    };

    const handleEditCategory = (category) => {
        setSelectedCategory(category);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSelectedCategory(null);
        fetchCategories(); // Refresh the category list
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen text-xl">
                Loading...
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Categories</h1>
                <button
                    onClick={handleAddCategory}
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                >
                    Add New Category
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {categories.map((category) => (
                    <div key={category.category_id} className="bg-white rounded shadow p-4">
                        <h2 className="text-2xl font-bold mb-2">{category.name}</h2>
                        <p className="text-gray-700 mb-4">
                            {category.description.length > 100
                                ? category.description.substring(0, 100) + '...'
                                : category.description}
                        </p>
                        <button
                            onClick={() => handleEditCategory(category)}
                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Edit
                        </button>
                    </div>
                ))}
            </div>

            {showModal && (
                <AddEditPlantCategoryForm
                    category={selectedCategory}
                    onClose={handleModalClose}
                />
            )}
        </div>
    );
}

export default PlantCategoryList;
